<template>
  <div id="app">
    <div :class="{blur:!project}">
      <Navbar></Navbar>
      <router-view />
    </div>
    <div class="mask" v-if="!project && isMounted">
      <div class="message">缺少参数: project</div>
    </div>
  </div>
</template>

<script>
import Navbar from '@/components/Navbar'
import { checkLogin } from '@/api'
import { isMobile } from './util'

export default {
  components: {
    Navbar
  },
  computed: {
    projectConfig () {
      return this.$store.state.projectConfig
    },
    project () {
      return this.$route.query.project
    }
  },
  data () {
    return {
      isMounted: false
    }
  },
  created () {
    // 获取实名认证配置
    this.$store.dispatch('getProjectConfig')
    // 获取购物车
    checkLogin().then(res => {
      if (!res.data.extraInfo) {
      } else {
        this.$store.dispatch('getCartItems')
      }
    })
  },
  mounted () {
    setTimeout(() => {
      this.isMounted = true
      console.log(isMobile(), window.config && window.config.baseUrl, this.project)
      if (isMobile() && this.project && window.config && window.config.baseUrl) {
        switch (window.config.baseUrl) {
          case 'https://pwxdev.cleartv.cn':
            location.href = 'https://pwxdev.cleartv.cn/frontend/mobile/#/?project=' + this.project
            break
          case 'https://pwx.cleartv.cn':
            location.href = 'https://pqncdn.cleartv.cn/mobile/#/?project=' + this.project
        }
      }
    }, 1000)
  }
}
</script>

<style lang="scss">
* {
  padding: 0;  margin: 0;
}
html {
  height: 100%;  font: 14px/1.5 Helvetica Neue,Helvetica,Arial,Microsoft Yahei,Hiragino Sans GB,Heiti SC,WenQuanYi Micro Hei,sans-serif;  background-color: #f4f4f5;
  body {
    position: relative;  min-height: 100%;  overflow: auto;

// background-image: url("~img/back.jpg");
    background-attachment: fixed;  background-position: center;  background-size: cover;
  }
}
li {
  list-style: none;
}
input {
  display: block; height: 32px; box-sizing: border-box; -webkit-appearance: none; padding: 0 10px; border: none; border: 1px solid #c2c2c2; border-radius: 4px;
}
.box-shadow {
  border: 1px solid #eee; box-shadow: 3px 3px 6px rgba($color: #000, $alpha: .1);
}
#app {
  padding-bottom: 100px;  font-family: 'Avenir', Helvetica, Arial, sans-serif; color: #4a4a4a; -webkit-font-smoothing: antialiased; -moz-osx-font-smoothing: grayscale;
}
.asterisk {
  color: red;
}
.bold-text {
  font-weight: bold;
}

.detail-dialog {
  .dialog-title {
    padding: 0 0 10px; font-size: 16px; font-weight: bold;
  }
  .dialog-info {
    padding-bottom: 30px;
  }
}

.guestList {
  span {
    display: inline-block; width: 20px;height: 20px; margin-right: 10px; line-height: 20px; color: #ed6b33; text-align: center; background: rgba(237, 107, 51, .1); border: 1px solid rgba(237, 107, 51, .6);
  }
  li {
    display: flex; padding: 10px; cursor: pointer; border-bottom: 1px dashed #ddd; align-items: center;
  }
  .guestItem {
    position: relative;  flex: 1;
  }
  .blank {
    position: absolute; top: 0; left: 0;display: flex; width: 100%;height: 100%; color: #999; justify-content: center; align-items: center;
  }
}

.protocol-wrap {
  padding: 10px; margin-top: 10px;  text-align: center; background: #fff; border-radius: 7px 7px 0 0;
  a {
    color: #000;  text-decoration: underline;
  }
}
.blur {
  filter: blur(5px);
}
.mask {
  position: fixed; top: 0; left: 0;display: flex; width: 100%;height: 100%; justify-content: center; align-items: center;
  .message {
    padding: 20px 50px; font-size: 16px;  color: red; background: #fff; border-radius: 10px; box-shadow: 0 0 20px rgba(0,0,0,.2);
  }
}

</style>
